import { Pagination } from 'ui/Pagination';
import BriefCard from './CreativeBriefs.BriefCard';
import type { CreativeBriefResponse, ToggleVisibilityFn } from './CreativeBriefs.types';
import { CardGrid, EmptyState, EmptyStateText, EmptyStateTitle } from './styles/briefCard.styles';

type BriefGridProps = {
  briefs: CreativeBriefResponse[];
  total: number;
  pageSize: number;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  loading: boolean;
  onToggleVisibility: ToggleVisibilityFn;
  updatingBriefIds: Set<string>;
  onBriefClick: (brief: CreativeBriefResponse) => void;
};

const BriefGrid = ({
  briefs,
  total,
  pageSize,
  currentPage,
  setCurrentPage,
  loading,
  onToggleVisibility,
  updatingBriefIds,
  onBriefClick
}: BriefGridProps) => {
  const totalPages = Math.ceil(total / pageSize);

  if (!loading && briefs.length === 0) {
    return (
      <EmptyState>
        <EmptyStateTitle>No briefs found</EmptyStateTitle>
        <EmptyStateText>Try adjusting your filters or check back later.</EmptyStateText>
      </EmptyState>
    );
  }

  return (
    <>
      <CardGrid disabled={loading}>
        {briefs.map(brief => (
          <BriefCard
            key={brief.briefId}
            brief={brief}
            onToggleVisibility={onToggleVisibility}
            updatingVisibility={updatingBriefIds.has(brief.briefId)}
            onClick={() => onBriefClick(brief)}
          />
        ))}
      </CardGrid>

      <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
    </>
  );
};

export default BriefGrid;
